Vue.component('ack-product-media-grid', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-product-media-grid',
    mounted() {
  
      
    },
    props:{
      mediaGridCollection: {
        type: Object,
        required: false
      },
      title: {
        type: String,
        default: ''

      },
      isMobile: {
        type: Boolean
      }
    },
    computed: {
      ...Vuex.mapGetters('shop', ['productList']),
      
    },
    data() {
      return {
      }
    },
    methods: {
      //...Vuex.mapActions(['sayHi', 'someAction']),
      //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
      
  
      
  
    },
    beforeDestroy() {
      
    },
    watch: {
      prop1: {
        handler() {
          
          
        },
        deep: false
      }
    }
  })